import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Movies from './pages/Movies';
import TVShows from './pages/TVShows';
import MusicVideos from './pages/MusicVideos';
import ContentDetail from './pages/ContentDetail';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import Favorites from './pages/Favorites';
import Profile from './pages/Profile';
import Subscription from './pages/Subscription';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import AuthCallback from './pages/AuthCallback';
import AdminDashboard from './pages/AdminDashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AccountDeletion from './pages/AccountDeletion';
import TermsOfUse from './pages/TermsOfUse';
import Support from './pages/Support';
import LearnMore from './pages/LearnMore';
import TVPairPhone from './pages/TVPairPhone';
import TVApp from './tv/TVApp';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-background text-foreground">
          <Routes>
            {/* TV app (FireStick / Android TV) - standalone, landscape, D-pad */}
            <Route path="/tv/*" element={<TVApp />} />

            {/* Standalone pages - no navbar */}
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/delete-account" element={<AccountDeletion />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/support" element={<Support />} />
            <Route path="/learn-more" element={<LearnMore />} />
            <Route path="/tv-pair" element={<TVPairPhone />} />
            
            {/* Main app routes with navbar */}
            <Route path="/*" element={
              <>
                <Navbar />
                <main className="md:ml-[20%] md:min-w-0 pt-16 md:pt-0">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/movies" element={<Movies />} />
                    <Route path="/tv-shows" element={<TVShows />} />
                    <Route path="/music-videos" element={<MusicVideos />} />
                    <Route path="/content/:id" element={<ContentDetail />} />
                    <Route path="/favorites" element={<Favorites />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/signin" element={<SignIn />} />
                    <Route path="/signup" element={<SignUp />} />
                    <Route path="/subscription" element={<Subscription />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                    <Route path="/auth/callback" element={<AuthCallback />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                  </Routes>
                </main>
              </>
            } />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
